export interface PrizmDocSourceCodePathOptions {
  readonly header: string;
  readonly package: string;
  readonly type: string;
  readonly path: string;
}
